import React from 'react'
import HomeContainer from '../Views/home'

function HomePage() {
  return <HomeContainer/>;
}

export default HomePage
